import _extends from "@babel/runtime/helpers/extends";
import { Observable } from 'rxjs';
import $ from 'jquery';
import { getUUID } from "../utils";
var LOCAL_PRINT_MESSAGE_TYPE = 3;
function cloudPrint(printData, config) {
  if (printData === void 0) {
    printData = {};
  }
  if (config === void 0) {
    config = {};
  }
  return new Observable(function (observer) {
    var printDataByConfig = _extends({}, printData.printConfig, {
      data: [printData]
    });
    var printTimes = config.printTimes || 1;
    var bus_id = printData.printConfig && printData.printConfig.bus_id || -1;
    var _printData = printData,
      _printData$printConfi = _printData.printConfig,
      printConfig = _printData$printConfi === void 0 ? {} : _printData$printConfi;
    var _printConfig$extraDat = printConfig.extraData,
      extraData = _printConfig$extraDat === void 0 ? {} : _printConfig$extraDat,
      printer = printConfig.printer;
    if (printTimes >= 1) {
      var documents = filterDoc(printDataByConfig);
      if (!documents) {
        throw new Error('打印文档协议不正确');
      }
      var _ref = extraData,
        _ref$printType = _ref.printType,
        printType = _ref$printType === void 0 ? '' : _ref$printType;
      printTimes -= 1;
      return observer.next({
        messageType: LOCAL_PRINT_MESSAGE_TYPE,
        bus_id: bus_id,
        data: _extends({
          requestID: getUUID(),
          version: '1.0',
          cmd: 'print',
          task: {
            printer: printer || '',
            preview: false,
            previewType: 'pdf',
            printType: printType,
            documents: documents,
            taskID: "" + new Date().getTime() + getUUID()
          }
        }, extraData),
        configName: getConfigName(printDataByConfig.data[0], config)
      });
    }
    if (config.refresh) {
      try {
        var _config, _config$refresh, _config$refresh$split;
        var refresh = (_config = config) === null || _config === void 0 ? void 0 : (_config$refresh = _config.refresh) === null || _config$refresh === void 0 ? void 0 : (_config$refresh$split = _config$refresh.split) === null || _config$refresh$split === void 0 ? void 0 : _config$refresh$split.call(_config$refresh, '@');
        if (refresh[0] && refresh[1]) {
          var _$, _$$click;
          (_$ = $(refresh[1])) === null || _$ === void 0 ? void 0 : (_$$click = _$.click) === null || _$$click === void 0 ? void 0 : _$$click.call(_$);
        }
      } catch (e) {
        console.error(e);
      }
    }
  });
}
function getConfigName(res, config) {
  if (config && config.configName) {
    return config.configName;
  }
  if (res.printConfig && res.printConfig.configName) {
    return res.printConfig.configName;
  }
  return '';
}
export function filterDoc(doc) {
  var documents = [];
  if (!doc.data || !doc.data.length) {
    throw new Error('print data error!');
  }
  for (var i = 0; i < doc.data.length; i++) {
    var nextDoc = getDocument(doc.data[i]);
    if (!nextDoc) {
      return false;
    }
    documents.push(nextDoc);
  }
  return documents;
}

// @ts-ignore
export function getDocs(printData, config) {
  if (printData === void 0) {
    printData = {};
  }
  if (config === void 0) {
    config = {
      printTimes: undefined,
      configName: '',
      refresh: ''
    };
  }
  var printDataByConfig = _extends({}, printData.printConfig, {
    data: [printData]
  });
  var printTimes = config.printTimes || 1;
  var bus_id = printData.printConfig && printData.printConfig.bus_id || -1;
  var _printData2 = printData,
    _printData2$printConf = _printData2.printConfig,
    printConfig = _printData2$printConf === void 0 ? {} : _printData2$printConf;
  var _printConfig$extraDat2 = printConfig.extraData,
    extraData = _printConfig$extraDat2 === void 0 ? {} : _printConfig$extraDat2;
  if (printTimes >= 1) {
    var documents = filterDoc(printDataByConfig);
    if (!documents) {
      throw new Error('打印文档协议不正确');
    }
    var _ref2 = extraData,
      _ref2$printType = _ref2.printType,
      printType = _ref2$printType === void 0 ? '' : _ref2$printType;
    printTimes -= 1;
    return {
      messageType: LOCAL_PRINT_MESSAGE_TYPE,
      bus_id: bus_id,
      data: _extends({
        requestID: getUUID(),
        version: '1.0',
        cmd: 'print',
        task: {
          printer: '',
          preview: false,
          previewType: 'pdf',
          printType: printType,
          documents: documents,
          taskID: "" + new Date().getTime() + getUUID()
        }
      }, extraData),
      configName: getConfigName(printDataByConfig.data[0], config)
    };
  }
  if (config.refresh) {
    try {
      var _config2, _config2$refresh, _config2$refresh$spli;
      var refresh = (_config2 = config) === null || _config2 === void 0 ? void 0 : (_config2$refresh = _config2.refresh) === null || _config2$refresh === void 0 ? void 0 : (_config2$refresh$spli = _config2$refresh.split) === null || _config2$refresh$spli === void 0 ? void 0 : _config2$refresh$spli.call(_config2$refresh, '@');
      if (refresh[0] && refresh[1]) {
        var _$2, _$2$click;
        (_$2 = $(refresh[1])) === null || _$2 === void 0 ? void 0 : (_$2$click = _$2.click) === null || _$2$click === void 0 ? void 0 : _$2$click.call(_$2);
      }
    } catch (e) {
      // todo
    }
  }
}
function getDocument(docData) {
  var documentID = getDocumentID();
  var contents = getContents(docData);
  return {
    documentID: documentID,
    contents: contents
  };
}
function getDocumentID() {
  return getUUID();
}
function getContents(data) {
  var contents = [];
  var templateUrl = getTemplateUrlFromConfig(data);
  var signature = getSignatureFromConfig(data);
  var list = data.data || [];
  for (var i = 0; i < list.length; i++) {
    var content = {};
    var printData = getPrintData(list[i]);
    var printTemplateUrl = getTemplateUrl(list[i]) || templateUrl;
    var printSignature = getSignature(list[i]) || signature;
    content = {
      data: printData,
      templateURL: printTemplateUrl,
      signature: printSignature
    };
    contents.push(content);
  }
  list = data.encryptedData || [];
  for (var _i = 0; _i < list.length; _i++) {
    contents.push(list[_i]);
  }
  return contents;
}
function getPrintData(data) {
  var res = data;
  res = HTMLDecode(data);
  return res;
}
function getTemplateUrl(data) {
  if (data.templateUrl) {
    return data.templateUrl;
  }
  return false;
}
function getSignature(data) {
  if (data.signature) {
    return data.signature;
  }
  return false;
}
function getTemplateUrlFromConfig(data) {
  var _data$printConfig;
  if (data !== null && data !== void 0 && (_data$printConfig = data.printConfig) !== null && _data$printConfig !== void 0 && _data$printConfig.templateUrl) {
    return data.printConfig.templateUrl;
  }
  return '';
}
function getSignatureFromConfig(data) {
  if (data.printConfig && data.printConfig.signature) {
    return data.printConfig.signature;
  }
  return '';
}
function HTMLDecode(text) {
  var temp = document.createElement('div');
  temp.innerHTML = JSON.stringify(text);
  var output = temp.innerText || temp.textContent;
  return JSON.parse(output);
}
export default cloudPrint;